/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Space_File_Preview_MissingInputs */



/**
* | output |
* | --- |
* | "The details of this change could not be read." |
*
* @param {Chat_Space_File_Preview_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_preview_missing = /** @type {((inputs?: Chat_Space_File_Preview_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Preview_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Einzelheiten dieser Änderung konnten nicht gelesen werden.")
	return /** @type {LocalizedString} */ ("The details of this change could not be read.")
});